export const MUTATION_GROUP = 'urlFields' as const;
